import React,{useEffect, useContext} from 'react';
import Header from '../components/header/Header';
import HeroPreview from '../components/hero/HeroPreview';
import HomeDemos from '../components/Preview/HomeDemos';
import PageDemos from '../components/Preview/PageDemos';
import Changelog from '../components/Preview/Changelog';
import PreviewFooter from '../components/footer/PreviewFooter';
import Purshase from '../components/Preview/Purshase';
import useDocumentTitle from '../components/useDocumentTitle';
import axios from 'axios';
import config from '../config';
import userContext from '../context/user/userContext';

const Preview = () => {
  let {userState, updateUserState} = useContext(userContext)
  // const token = localStorage.getItem("token");

  // const fetchUserLoggedIn = async()=>{
  //     console.log(token)
  //     if(token){
  //         let response = await axios.get(config.BACKEND.URL+"/user/auth/profile",{
  //           headers:{
  //             "x-api-key":"meritverse",
  //             "auth-token":token
  //           }  
  //         });
  //         console.log(response.data)
  //         if(response.data.success){
  //             console.log(response.data.result.user)
  //             updateUserState({
  //               ...userState,
  //               loggedIn:true,
  //               profile:response.data.result.user,
  //               token:token,
  //               userId:response.data.result.user._id
  //             })

  //             localStorage.setItem("token", token)
  //             localStorage.setItem("userId", response.data.result.user._id)

  //         }
  //     }  
  // }

  // useEffect(()=>{
  //         fetchUserLoggedIn()
  // },[])

  useDocumentTitle(' MeritVerse');
  return (
    <div>
      <Header />
      <HeroPreview />
      <br />
      {/* <HomeDemos /> */}
      {/* <PageDemos /> */}
      {/* <Changelog /> */}
      <Purshase />
      <PreviewFooter />
    </div>
  );
};

export default Preview;
